module.exports = __webpack_public_path__ + "static/fg-01dcb54b746df8d66e3613ecce3c913e.png";